// error-messages.ts
export const ACCESS_DENIED_MESSAGE = 'Access denied. Admins only.'
